module.exports = __webpack_public_path__ + "static/media/business2.23807b69.png";